// import PieChart from "components/charts/PieChart";
// import Card from "components/card";

// const pieChartOptions = {
//   labels: ["Open", "In Progress", "Resolved", "Escalated"],
//   colors: ["#4318FF", "#23905f", "#6AD2FF", "#FF0000"],
//   chart: {
//     width: "50px",
//   },
//   states: {
//     hover: {
//       filter: {
//         type: "none",
//       },
//     },
//   },
//   legend: {
//     show: false,
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   hover: { mode: null },
//   plotOptions: {
//     donut: {
//       expandOnClick: false,
//       donut: {
//         labels: {
//           show: false,
//         },
//       },
//     },
//   },
//   fill: {
//     colors: ["#4318FF", "#23905f", "#6AD2FF", "#FF0000"],
//   },
//   tooltip: {
//     enabled: true,
//     theme: "dark",
//     style: {
//       fontSize: "12px",
//       fontFamily: undefined,
//       backgroundColor: "#000000"
//     },
//   },
// };

// const pieChartData = [43, 25, 12, 20];

// const PieChartCard = () => {
//   return (
//     <Card extra="rounded-[20px] p-3">
//       <div className="flex flex-row justify-between px-3 py-2">
//           <h4 className="text-lg font-bold text-navy-700 dark:text-white">
//             Ticket Distribution
//           </h4>
//       </div>

//       <div className="mb-auto flex h-[220px] w-full items-center justify-center">
//         <PieChart options={pieChartOptions} series={pieChartData} />
//       </div>
//       <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
//         <div className="flex flex-col items-center justify-center">
//           <div className="flex items-center justify-center">
//             <div className="h-2 w-2 rounded-full bg-[black]" />
//             <p className="ml-1 text-sm font-normal text-gray-600">Total</p>
//           </div>
//           <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
//             700
//           </p>
//         </div>

//         <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

//         <div className="flex flex-col items-center justify-center">
//           <div className="flex items-center justify-center">
//             <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
//             <p className="ml-1 text-sm font-normal text-gray-600">Resolved</p>
//           </div>
//           <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
//             25%
//           </p>
//         </div>
//       </div>
//     </Card>
//   );
// };

// export default PieChartCard;

import { useState, useEffect } from "react";
import PieChart from "components/charts/PieChart";
import Card from "components/card";
import { fetchData } from "services/ApiFetching"; // Your fetch utility

const pieChartOptionsBase = {
  labels: ["Open", "In Progress", "Resolved", "Escalated"],
  colors: ["#4318FF", "#23905f", "#6AD2FF", "#FF0000"],
  chart: {
    width: "50px",
  },
  states: {
    hover: { filter: { type: "none" } },
  },
  legend: { show: false },
  dataLabels: { enabled: false },
  hover: { mode: null },
  plotOptions: {
    donut: {
      expandOnClick: false,
      labels: { show: false },
    },
  },
  fill: {
    colors: ["#4318FF", "#23905f", "#6AD2FF", "#FF0000"],
  },
  tooltip: {
    enabled: true,
    theme: "dark",
    style: {
      fontSize: "12px",
      backgroundColor: "#000000",
    },
  },
};

const PieChartCard = ({ selectedDate }) => {
  const [pieChartData, setPieChartData] = useState([0, 0, 0, 0]);
  const [totalTickets, setTotalTickets] = useState(0);

  function formatDateForApi(date) {
  const pad = (n) => (n < 10 ? "0" + n : n);
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate())
  );
}

  useEffect(() => {
    const fetchPieChartData = async () => {
      if (!selectedDate) return;

      try {
        const formattedDate = formatDateForApi(selectedDate)
        const response = await fetchData(`dashboard/getDailyCount?date=${formattedDate}`);
        if (response?.counts) {
          const { open, in_progress, resolved, escalated } = response.counts;
          setPieChartData([open, in_progress, resolved, escalated]);
          setTotalTickets(response.total);
        }
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
      }
    };

    fetchPieChartData();
  }, [selectedDate]);

  // Calculate percentage resolved for display (example)
  const resolvedPercent = totalTickets > 0 ? Math.round((pieChartData[2] / totalTickets) * 100) : 0;

  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 py-2">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">Ticket Distribution</h4>
      </div>

      <div className="mb-auto flex h-[220px] w-full items-center justify-center">
        {totalTickets > 0 ? (
          <PieChart options={pieChartOptionsBase} series={pieChartData} />
        ) : (
          <p className="text-gray-500 text-lg">No Data Available</p>
        )}
      </div>

      <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[black]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Total</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">{totalTickets}</p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Resolved</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">{resolvedPercent}%</p>
        </div>
      </div>
    </Card>
  );
};

export default PieChartCard;
